import { render } from "./MediaBlockItem.vue?vue&type=template&id=3491aa91&scoped=true&ts=true"
import script from "./MediaBlockItem.vue?vue&type=script&lang=ts"
export * from "./MediaBlockItem.vue?vue&type=script&lang=ts"

import "./MediaBlockItem.vue?vue&type=style&index=0&id=3491aa91&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3491aa91"]])

export default __exports__